export default __webpack_public_path__ + "static/media/boatPartyLogo.ec696b65.png";